//@ts-check
import deepMerge from '../utils/deepMerge';
import getDotProp from '../utils/getDotProp';
import defaultTheme from './theme';
import { getVariant } from './variants';
import red from '@material-ui/core/colors/red';
var DANGER_COLOR = red[400];

var getBaseTheme = function getBaseTheme(userTheme) {
  if (!userTheme) return defaultTheme;
  if (userTheme.variant) return deepMerge(defaultTheme, getVariant(userTheme.variant));
  return defaultTheme;
};

var mergeTheme = function mergeTheme(userTheme) {
  var baseTheme = getBaseTheme(userTheme);
  var mergedTheme = deepMerge(baseTheme, userTheme);
  return mergedTheme;
};
/**
 * @param {import("theme/types").PartialEcrionTheme} userTheme
 * @returns {import("theme/types").EcrionTheme}
 */


var createTheme = function createTheme(userTheme) {
  var theme = mergeTheme(userTheme);

  theme.getProps = function (name) {
    return getDotProp(this.common, name + '.props') || {};
  };

  theme.getStyle = function (name) {
    return getDotProp(this.common, name + '.style') || {};
  };

  theme.getColor = function (color) {
    if (!color) return this.palette['primary'].main;
    var out = color;
    var colorPalette = this.palette[color];
    if (colorPalette) out = colorPalette.main;else if (color === 'danger') out = DANGER_COLOR;
    return out;
  };

  return theme;
};

export default createTheme;